var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",style:('margin-top : '+_vm.height/2+'px')},[_c('h1',[_vm._v(" Vous allez être redirigé vers le site Adhérent d’ici quelques secondes.")])])}
var staticRenderFns = []

export { render, staticRenderFns }